module.exports = __WEBPACK_EXTERNAL_MODULE_VBo9__;